import { render } from "./HotTopics.vue?vue&type=template&id=980d7d2e&scoped=true"
import script from "./HotTopics.vue?vue&type=script&lang=js"
export * from "./HotTopics.vue?vue&type=script&lang=js"

import "./HotTopics.vue?vue&type=style&index=0&id=980d7d2e&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980d7d2e"]])

export default __exports__